import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { localizePath } from '../../helper/localizedPath';

export default function MenuWidget({menuItems, menuHeading, variant}) {
  const { i18n } = useTranslation();

  return (
    <>
      {menuHeading && <h2 className="cs-widget_title">{menuHeading}</h2>}
      <ul className={`${variant ? `cs-menu_widget ${variant}` : 'cs-menu_widget cs-style1'} cs-mp0`}>
        {menuItems.map((item, index) => (
          <li key={index}>
            {item.href ? <Link to={localizePath(item.href, i18n.language === 'en' ? 'en' : 'cs')}>{item.title}</Link> : item.title}
          </li>
        ))}
      </ul>
    </>
  )
}
